<template>
    <div class="background">
        <div v-if="validationTip" class="validationTip">{{ validationTip }}</div>
        <div v-if="showAgreementModal" class="agreementModalMask">
            <div class="agreementModal" @click.stop>
                <div class="agreementModalTitle">服务协议与隐私条款</div>
                <div class="agreementModalClose" @click="closeAgreementModal">×</div>
                <div class="agreementModalContent">我已阅读并同意<span @click="openPDF()" style="color: #1677FF;cursor: pointer;">《吉林一号在线访问产品使用协议》</span></div>
                <div class="agreementModalActions">
                    <div class="agreementModalBtn agreementModalBtnCancel" @click="closeAgreementModal">取消</div>
                    <div class="agreementModalBtn agreementModalBtnConfirm" @click="confirmAgreement">确认</div>
                </div>
            </div>
        </div>
        <!-- 认证身份弹窗 -->
        <div class="shadow" v-if="shadowTip">
            <div class="shadowWhite">
                <img src="../../../assets/calendar/日历关闭.png" alt="" class="shadowClose" @click="shadowTip=false">
                <div class="shadowText1">用户身份认证</div>
                <div class="shadowText2">根据国家地理信息安全与保密相关规定，为规范数据使用，保障您的合法权益，购买和使用卫星遥感数据需完成<span style="font-weight: 600;">机构企业用户</span>/<span style="font-weight: 600;">教育科研用户</span>认证。（认证后可享受会员价格）</div>
                <div class="shadowSel" @click="jumpWithPermission('可游客','/store/ApplyGovernmentMember','/rskit')">
                    <img src="../../../assets/dataPack/企业用户.png" alt="" style="position: absolute;width: 100%;height: 100%;">
                </div>
                <div class="shadowSel" @click="jumpWithPermission('可游客','/store/OpenEducationalCertification','/rskit')" style="left: 400px;">
                    <img src="../../../assets/dataPack/教育用户.png" alt="" style="position: absolute;width: 100%;height: 100%;">
                </div>
            </div>
        </div>
        <div class="right">
            <div class="rightText1">订单详情</div>
            <div class="rightText2">吉林一号网账号 {{ getCookie("userId") }}</div>
            <div class="rightLine1"></div>
            <div class="rightText3">图源包年</div>
            <div class="rightText4" v-if="premiumCount > 0">
                <span class="rightText4Style1">高级图源 | 1年</span>
                <span class="rightText4Style1">{{ premiumArea }}km²</span>
                <span class="rightText4Style2">￥{{ premiumTotalPriceText }}</span>
            </div>
            <div class="rightText4" v-if="basicCount > 0">
                <span class="rightText4Style1">基础图源 | 1年</span>
                <span class="rightText4Style1">{{ basicArea }}km²</span>
                <span class="rightText4Style2">￥{{ basicTotalPriceText }}</span>
            </div>
            <div class="rightLine1" style="margin-top: 4.1%;"></div>
            <div class="rightText5">
                <span class="rightText5Style1">实付金额</span>
                <span class="rightText5Style2">￥{{ payFinalText }}</span>
            </div>
            <img src="../../../assets/dataPack/purchaseData/联系商务经理.png" alt="" class="rightIcon1" @click="$router.push('/onlineService/Home')">
            <div class="rightLine2"></div>
            <div class="rightText5" style="height: 32px;margin-top: 4%;">
                <span class="rightText5Style1" style="font-size: 24px;height: 32px;line-height: 32px;">本次应付</span>
                <span class="rightText5Style2"  style="font-size: 24px;height: 32px;line-height: 32px;">￥{{ payFinalText }}</span>
            </div>
            <div class="rightText6">
                <img src="../../../assets/dataPack/purchaseData/未选中.png" alt="" v-if="!isAgreed" class="rightIcon2" @click="isAgreed=true"> 
                <img src="../../../assets/dataPack/purchaseData/选中.png" alt="" v-if="isAgreed" class="rightIcon2" @click="isAgreed=false">
                <div class="rightText6Style">我已阅读并同意<span @click="openPDF()" style="color: #1677FF;cursor: pointer;">《吉林一号在线访问产品使用协议》</span></div>
            </div>
            <div class="rightBtn" @click="handleNextStep">下一步</div>
        </div>
        <div class="left">
            <div class="leftCtn">
                <div class="leftText1">选购产品</div>
                <img src="../../../assets/dataPack/AnnualPurchase/对号.png" alt="" class="leftImg1" style="cursor: pointer;" @click="goBackToAreaSelection">
                <div class="leftTxt1" style="cursor: pointer;" @click="goBackToAreaSelection">选择区域</div>
                <img src="../../../assets/dataPack/rsManage/右箭头.png" alt="" class="leftImg2" style="cursor: pointer;" @click="goBackToSourceSelection">
                <img src="../../../assets/dataPack/AnnualPurchase/对号.png" alt="" style="right: 184px;cursor: pointer;" class="leftImg1" @click="goBackToSourceSelection">
                <div class="leftTxt1" style="right: 124px;cursor: pointer;" @click="goBackToSourceSelection">选择图源</div>
                <img src="../../../assets/dataPack/rsManage/右箭头.png" alt="" style="right: 96px;" class="leftImg2">
                <div class="leftCircle">3</div>
                <div class="leftTxt1" style="right: 0px;font-weight: 500;color: rgba(0,0,0,0.85);">提交订单</div>
                <div class="leftWhite">
                    <img src="../../../assets/dataPack/AnnualPurchase/图源包年.png" alt="" class="leftIcon1">
                    <div class="leftText2">图源包年</div>
                    <div class="leftLine1"></div>
                    <div class="leftText4">已选区域</div>
                    <div class="leftMap">
                        <l-map
                            :maxBounds="maxBounds"
                            :minZoom="parseInt(2)"
                            :maxZoom="parseInt(12)"
                            ref="map"
                            style="width: 100%; height: 100%;"
                            :zoom="zoom"
                            :center="center"
                            :options="option"
                            :class="$store.state.search.targetSelecting ? 'leaflet-crosshair': ''"
                        >
                            <template mark="map">
                                <l-tile-layer ref="mapLayer" :url="mapUrl" :options="$store.state.map.mapSubdomains" />
                                <!-- <l-tile-layer ref="infoLayer" v-show="!!$store.state.map.infoUrl" :url="$store.state.map.infoUrl"  :options="$store.state.map.mapSubdomains" /> -->
                            </template>
                            <l-geo-json
                                v-if="regionGeo.geojson"
                                :geojson="regionGeo.geojson"
                                :optionsStyle="geojsonStyle"
                            ></l-geo-json>
                        </l-map>
                        <img src="../../../assets/dataPack/AnnualPurchase/查看.png" alt="" class="leftImg3" @click="regionPanelShow=true">
                    </div>
                    <div class="leftContract" style="margin-top: 16px;">区域名称
                        <input v-if="canEditAreaName" type="text" v-model="areaName" placeholder="必填，请输入区域名称" :class="areaNameError ? 'leftContractInput leftContractInputError' : 'leftContractInput'" style="left: 96px;width: 548px;" maxlength="30">
                        <div v-else :class="['leftContractInput', 'leftContractInputReadonly', { leftContractInputReadonlyPlaceholder: !areaName || !String(areaName).trim() }]" style="left: 96px;width: 548px;">{{ (areaName && String(areaName).trim()) || '必填，请输入区域名称' }}</div>
                    </div>
                    <div class="leftText4" style="margin-top: 40px;">选购图源</div>
                    <div class="leftTxt2">{{ mkName }}</div>
                    <div class="leftText8" style="margin-top: 40px;">电子合同</div>
                    <div class="leftText9" style="top: 484px;">默认签署电子合同，如果需要纸质合同可联系商务经理</div>
                    <div :class="contractError ? 'leftContract leftContractError' : 'leftContract'">
                        <input type="text" placeholder="委托方（甲方）名称  必填，请输入委托方（甲方）名称" v-model="contractName" :class="contractError ? 'leftContractInput leftContractInputError' : 'leftContractInput'">
                    </div>
                    <div class="leftText8">填写数据用途</div>
                    <div :class="dataFieldError ? 'leftContract leftContractNarrow leftContractError leftContractSelect' : 'leftContract leftContractNarrow leftContractSelect'" style="margin-top: 23px;" @click.stop>
                        <div :class="dataFieldError ? 'leftSelectPlaceholder leftSelectPlaceholderError' : 'leftSelectPlaceholder'" v-if="!dataUseField">数据应用领域  &nbsp;  必选，请选择数据应用领域</div>
                        <div :class="dataFieldError ? 'leftSelectInput leftSelectInputError' : 'leftSelectInput'" @click="toggleDataFieldDropdown">
                            <span class="leftSelectValueText">{{ dataUseField }}</span>
                        </div>
                        <div class="leftSelectPanel" v-if="showDataFieldDropdown">
                            <div class="leftSelectOption" v-for="item in dataUseFieldOptions" :key="item" @click="selectDataUseField(item)">
                                {{ item }}
                            </div>
                        </div>
                    </div>
                    <div :class="dataDetailError ? 'leftContract leftContractError' : 'leftContract'" style="margin-top: 23px;">
                        <input type="text" placeholder="数据具体用途   必填，请填写数据具体用途" v-model="dataUseDetail" :class="dataDetailError ? 'leftContractInput leftContractInputError' : 'leftContractInput'">
                    </div>
                    <div class="leftText8" style="margin-top: 40px;">订单备注</div>
                    <div class="leftContract" style="margin-top: 23px;">
                        <input type="text" placeholder="订单备注  选填，请输入订单备注" v-model="remark" class="leftContractInput">
                    </div>
                    <div class="leftText10">流量生效时间&nbsp;&nbsp; {{ currentDate }} &nbsp;&nbsp;|&nbsp;&nbsp; 流量失效时间&nbsp;&nbsp; {{ oneYearLater }}</div>
                </div>
            </div>

        </div>

        <div class="regionPanelBak" v-if="regionPanelShow">
            <div class="regionPanel">
                <div class="regionPanelTitle">
                    <span>浏览已选区域</span>
                    <img src="../../../assets/dataPack/rsManage/关闭.png" alt="" @click="regionPanelShow=false">
                </div>
                <div class="regionPanelMap">
                    <l-map
                        :maxBounds="maxBounds1"
                        :minZoom="parseInt(2)"
                        :maxZoom="parseInt(12)"
                        ref="map1"
                        style="width: 100%; height: 100%;"
                        :zoom="zoom1"
                        :center="center1"
                        :options="option1"
                        :class="$store.state.search.targetSelecting ? 'leaflet-crosshair': ''"
                    >
                        <template mark="map1">
                            <l-tile-layer ref="mapLayer1" :url="mapUrl" :options="$store.state.map.mapSubdomains" />
                            <!-- <l-tile-layer ref="infoLayer" v-show="!!$store.state.map.infoUrl" :url="$store.state.map.infoUrl"  :options="$store.state.map.mapSubdomains" /> -->
                        </template>
                        <l-geo-json
                            :geojson="regionGeo.geojson"
                            :optionsStyle="geojsonStyle"
                        ></l-geo-json>
                    </l-map>
                </div>
                <div class="regionPanelTips">提示：该地图仅作示意，实际以选购图源为准</div>
            </div>
        </div>
    </div>
</template>
<script>
import { rootUrl } from '@/globalConfig'
import WKT from "terraformer-wkt-parser"
import L from 'leaflet'
import { LMap,LMarker,LTileLayer,LGeoJson,LWMSTileLayer} from 'vue2-leaflet'
export default {
    name: "submitOrder",
    components: {
        LMap,
        LTileLayer,
        LGeoJson,
    },
    data() {
        return { 
            orderDraft: null,
            areaName:'',
            areaNameError:false,
            remark:'',
            currentDate:'',
            oneYearLater:'',
            isAgreed:false,
            contractName:'',
            contractError:false,
            dataUseField:'',
            dataUseDetail:'',
            dataFieldError:false,
            dataDetailError:false,
            validationTip:'',
            tipTimer:null,
            showAgreementModal:false,
            showDataFieldDropdown:false,
            shadowTip:false,
            dataUseFieldOptions:[
                '国土安全',
                '地理测绘',
                '城乡建设与规划',
                '农林生产',
                '智慧城市',
                '生态环保',
                '金融保险',
                '能源',
                '应急及灾害监测',
                '海洋',
                '水利水电',
                '交通运输',
                '地质监测',
                '司法',
                '科教文卫',
            ],

            regionPanelShow: false,

            // leaflet参数
            zoom: 4,
            center: L.latLng(33.978292, 105.395057),
            maxBounds: L.latLngBounds([[85, -180], [-85, 180]]),
            zoom1: 4,
            center1: L.latLng(33.978292, 105.395057),
            maxBounds1: L.latLngBounds([[85, -180], [-85, 180]]),
            
            mapUrl:`https://api.jl1mall.com/getMap/{z}/{x}/{-y}?mk=2d9bf902749f1630bc25fc720ba7c29f&tk=b9ae773d2fc3c91791e9edb2ba114911&vf=0`,
            // subdomains: this.$store.state.mapSubdomains,
            option: { zoomControl: false, attributionControl: false, renderer: L.canvas() },
            option1: { zoomControl: false, attributionControl: false, renderer: L.canvas() },
            geojsonStyle: {
                color: '#f4c639',
                fillColor: '#f4c639',
                weight: 2,
                fillOpacity: 0
            },
            regionGeo: {
                geojson: '',
                area:''
            },
        }
    },
    computed:{
        mkName(){
            return (this.orderDraft && this.orderDraft.mkName) || '';
        },
        regionArea(){
            return Number((this.orderDraft && this.orderDraft.regionArea) || 0);
        },
        basicCount(){
            const list = (this.orderDraft && this.orderDraft.mkList) || [];
            return list.filter(item => Number(item.mkType) === 1 || Number(item.mkType) === 4).length;
        },
        premiumCount(){
            const list = (this.orderDraft && this.orderDraft.mkList) || [];
            return list.filter(item => Number(item.mkType) === 2 || Number(item.mkType) === 3).length;
        },
        basicArea(){
            return (this.basicCount * this.regionArea).toFixed(3);
        },
        premiumArea(){
            return (this.premiumCount * this.regionArea).toFixed(3);
        },
        basicTotalPriceText(){
            return Number((this.orderDraft && this.orderDraft.basicPrice) || 0).toFixed(2);
        },
        premiumTotalPriceText(){
            return Number((this.orderDraft && this.orderDraft.premiumPrice) || 0).toFixed(2);
        },
        payFinalText(){
            return Number((this.orderDraft && this.orderDraft.payFinal) || 0).toFixed(2);
        },
        /** 与 purchaseData 一致：仅上传矢量(1)、绘制区域(3)可改区域名称 */
        canEditAreaName(){
            if (!this.orderDraft) {
                return true;
            }
            const t = this.orderDraft.curPlaceTab;
            if (t === undefined || t === null) {
                return true;
            }
            const tab = Number(t);
            return tab === 1 || tab === 3;
        },
    },
    mounted(){
        this.getDay()
        document.addEventListener('click', this.closeDataFieldDropdown);
    },
    beforeDestroy() {
        if (this.tipTimer) {
            clearTimeout(this.tipTimer);
            this.tipTimer = null;
        }
        document.removeEventListener('click', this.closeDataFieldDropdown);
    },
    created(){
        this.loadOrderDraft();
    },
    watch:{
        areaName(newVal) {
            if (newVal && newVal.trim()) {
                this.areaNameError = false;
            }
        },
        contractName(newVal) {
            if (newVal && newVal.trim()) {
                this.contractError = false;
            }
        },
        dataUseField(newVal) {
            if (newVal) {
                this.dataFieldError = false;
            }
        },
        dataUseDetail(newVal) {
            if (newVal && newVal.trim()) {
                this.dataDetailError = false;
            }
        },
        regionPanelShow(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.$refs.map1.mapObject.fitBounds(L.geoJSON(this.regionGeo.geojson).getBounds())
                })
            }
        }
    },
    methods:{
        getKey() {
            return localStorage.getItem("token");
        },
        jumpWithPermission(type,path,fromUrl){
            //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
            //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
            let loginUserId=localStorage.getItem('userId');//是否已登录
            let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
            if(type=='可游客'){
                if(fromUrl){
                    window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                }
                else {
                    window.open(rootUrl+path,"_self")
                }
            }else if(type=='仅登录'){
                //已登录
                if(loginUserId){
                    if(fromUrl){
                        window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+path,"_self")
                    }
                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }else if(type=='仅实名'){
                //已登录
                if(loginUserId){
                    //已实名
                    if(authentication=='0'){
                        if(fromUrl){
                            window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                        }
                        else {
                            window.open(rootUrl+path,"_self")
                        }
                    }
                    //未实名
                    else {
                        window.open(rootUrl+'/Authentication',"_self")
                    }

                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }
        },
        checkAndHandleAuthentication(){
          let loginUserId=localStorage.getItem('userId');//是否已登录
          let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
          if(!loginUserId){
            this.jumpWithPermission('仅登录','/Login','/rskit/')
          }
          else if(authentication!='0'){
            this.jumpWithPermission('仅实名','/Authentication','/rskit/')
          }
          return true;
        },
        loadOrderDraft() {
            const draft = localStorage.getItem('annualPurchaseOrderDraft');
            console.log(draft);
            
            if (!draft) {
                this.orderDraft = null;
                return;
            }
            let parsed;
            try {
                parsed = JSON.parse(draft);
            } catch (e) {
                this.orderDraft = null;
                return;
            }
            this.orderDraft = parsed;
            console.log(this.orderDraft);
            this.areaName = this.orderDraft.regionName || '';

            // 地图区域渲染单独处理：解析失败不应影响订单数据展示
            try {
                const shape = this.orderDraft.shape;
                if (shape) {
                    this.regionGeo.geojson = WKT.parse(shape);
                    this.$nextTick(() => {
                        if (this.$refs.map && this.$refs.map.mapObject && this.regionGeo.geojson) {
                            this.$refs.map.mapObject.fitBounds(L.geoJSON(this.regionGeo.geojson).getBounds());
                        }
                    });
                }
            } catch (e) {
                console.warn('区域图形解析失败', e);
            }
        },
        getDay(){
            const today = new Date();
            const currentYear = today.getFullYear();
            const currentMonth = String(today.getMonth() + 1).padStart(2, '0');
            const currentDay = String(today.getDate()).padStart(2, '0');
            this.currentDate = `${currentYear}/${currentMonth}/${currentDay}`;
            // 一年后的第二天（用 Date 构造自动处理跨月/跨年，如 2/29 场景）
            const endDate = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate() + 1);
            const endYear = endDate.getFullYear();
            const endMonth = String(endDate.getMonth() + 1).padStart(2, '0');
            const endDay = String(endDate.getDate()).padStart(2, '0');
            this.oneYearLater = `${endYear}/${endMonth}/${endDay}`;
        },
        showValidationTip(message) {
            this.validationTip = message;
            if (this.tipTimer) {
                clearTimeout(this.tipTimer);
            }
            this.tipTimer = setTimeout(() => {
                this.validationTip = '';
                this.tipTimer = null;
            }, 2500);
        },
        closeAgreementModal() {
            this.showAgreementModal = false;
        },
        confirmAgreement() {
            this.isAgreed = true;
            this.handleNextStep()
            this.showAgreementModal = false;
        },
        toggleDataFieldDropdown() {
            this.showDataFieldDropdown = !this.showDataFieldDropdown;
        },
        selectDataUseField(value) {
            this.dataUseField = value;
            this.showDataFieldDropdown = false;
        },
        closeDataFieldDropdown() {
            this.showDataFieldDropdown = false;
        },
        goBackToAreaSelection() {
            this.$router.push({ path: '/AnnualPurchase/annualPurchaseData', query: { backStep: '1' } });
        },
        goBackToSourceSelection() {
            this.$router.push({ path: '/AnnualPurchase/annualPurchaseData', query: { backStep: '2' } });
        },
        handleNextStep() {
            this.areaNameError = false;
            this.contractError = false;
            this.dataFieldError = false;
            this.dataDetailError = false;
            if (!this.areaName || !this.areaName.trim()) {
                this.areaNameError = true;
                this.showValidationTip('请填写区域名称');
                return;
            }
            if (!this.contractName || !this.contractName.trim()) {
                this.contractError = true;
                this.showValidationTip('请先填写委托方（甲方）名称');
                return;
            }
            if (!this.dataUseField) {
                this.dataFieldError = true;
                this.showValidationTip('请选择数据应用领域');
                return;
            }
            if (!this.dataUseDetail || !this.dataUseDetail.trim()) {
                this.dataDetailError = true;
                this.showValidationTip('请填写数据具体用途');
                return;
            }
            if (!this.isAgreed) {
                this.showAgreementModal = true;
                return;
            }
            if (!this.orderDraft) {
                this.showValidationTip('订单数据缺失，请返回上一步重新选择');
                return;
            }
            const mkList = this.orderDraft.mkList;
            if (!Array.isArray(mkList) || !mkList.length) {
                this.showValidationTip('图源数据异常，请返回重新选择');
                return;
            }
            this.axios.get('/loginapi/getUserForUserCenter', {
                headers: {
                    Authorization: 'Bearer ' + this.getKey(),
                },
            }).then((res) => {
                if (res.status === 200) {
                    const certificationIdentity = res.data && res.data.data && res.data.data.certificationIdentity;
                    if (certificationIdentity != '2' && certificationIdentity != '3') {
                        this.shadowTip = true;
                    } else {
                        this.createAnnualOrder();
                    }
                } else {
                    alert('系统错误');
                }
            });
        },
        createAnnualOrder() {
            if (!this.orderDraft) {
                this.showValidationTip('订单数据缺失，请返回上一步重新选择');
                return;
            }
            const mkList = this.orderDraft.mkList;
            if (!Array.isArray(mkList) || !mkList.length) {
                this.showValidationTip('图源数据异常，请返回重新选择');
                return;
            }
            const payload = {
                userClientName: this.contractName.trim(),
                areaId: this.orderDraft.areaId != null ? this.orderDraft.areaId : null,
                shape: this.orderDraft.shape != null ? this.orderDraft.shape : null,
                regionName: this.areaName.trim(),
                regionArea: Number(this.orderDraft.regionArea),
                mkName: this.orderDraft.mkName,
                basicPrice: Number(this.orderDraft.basicPrice),
                premiumPrice: Number(this.orderDraft.premiumPrice),
                payFinal: Number(this.orderDraft.payFinal),
                applicationField: this.dataUseField,
                dataUsage: this.dataUseDetail.trim(),
                remark: (this.remark && this.remark.trim()) || '',
                mkList,
            };
            this.axios.post('/tileflowapi/flow/package/createAnnualOrder', payload, {
                headers: {
                    Authorization: 'Bearer ' + this.getKey(),
                    'Content-Type': 'application/json',
                },
            }).then((res) => {
                const body = res && res.data;
                if (body && Number(body.code) === 200 && body.data) {
                    this.$router.push({
                        path: '/demandSubmit',
                        query: {
                            id: body.data,
                            orderScene: 'annualPurchase',
                        },
                    });
                    return;
                }
                const msg = (body && (body.msg || body.message)) || '创建订单失败';
                this.showValidationTip(msg);
            }).catch((err) => {
                const msg = (err && err.response && err.response.data && (err.response.data.msg || err.response.data.message))
                    || err.message
                    || '创建订单失败';
                this.showValidationTip(msg);
            });
        },
         openPDF(){
            window.open("https://files.jl1mall.com/jl1store/document/吉林一号在线访问产品使用协议.pdf")
        },
    }
}
</script>
<style scoped>
.background{
    position: relative;
    margin-top: 76px;
    margin-left: 0;
    width: 100vw;
    height: calc(100vh - 76px);
    background-image: url(../../../assets/dataPack/purchaseData/背景.png);
    background-position: center;
    background-size: cover;
}
.right{
    position: absolute;
    top: 0;
    right: 0;
    width: 37.5%;
    height: 100%;
    background: #FFFFFF;
    padding-bottom: 20px;
    overflow-y: auto;
    overflow-x: hidden;
}
.rightText1{
    position: relative;
    margin-top: 6.3%;
    margin-left: 8.8%;
    width: auto;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: rgba(0,0,0,0.85);
    line-height: 32px;
}
.rightText2{
    position: relative;
    margin-top: 1.6%;
    margin-left: 8.8%;
    width: auto;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 22px;
}
.rightLine1{
    position: relative;
    margin-left: 8.8%;
    margin-top: 3.2%;
    width:82.4%;
    height: 1px;
    border-top: 1px solid #D9D9D9;
}
.rightText3{
    position: relative;
    margin-top: 4%;
    margin-left: 8.8%;
    width: auto;
    height: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0,0,0,0.85);
    line-height: 24px;
}
.rightText4{
    position: relative;
    margin-left: 8.8%;
    margin-top:1.2%;
    width:82.4%;
    height: 28px;
    display: flex;
    justify-content: space-between; 
    align-items: center; 
}
.rightText4Style1{
    height: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 28px;
}
.rightText4Style2{
    height: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #000000;
    line-height: 28px;
}
.rightText5{
    position: relative;
    margin-left: 8.8%;
    margin-top:3.8%;
    width:82.4%;
    height: 28px;
    display: flex;
    justify-content: space-between; 
    align-items: center;
}
.rightText5Style1{
    height: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0,0,0,0.85);
    line-height: 28px;
}
.rightText5Style2{
    height: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 20px;
    color: #F5810B;
    line-height: 28px;
}
.rightIcon1{
    position: relative;
    display: block;
    margin-top: 30.3%;
    margin-left: 70.5%;
    cursor: pointer;
}
.rightLine2{
    position: relative;
    margin-top: 0;
    width: 100%;
    height: 1px;
    border-top: 1px dashed #D9D9D9;
}
.rightText6{
    position: relative;
    margin-left: 8.8%;
    margin-top: 2.4%;
    width:82.4%;
    height: 20px;
}
.rightIcon2{
    position: absolute;
    width: 16px;
    top: 2px;
    cursor: pointer;
}
.rightText6Style{
    position: absolute;
    left: 24px;
    width:auto;
    height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: rgba(0,0,0,0.65);
    line-height: 20px;
}
.rightBtn{
    position: relative;
    margin-left: 8.8%;
    margin-top:5%;
    width:82.4%;
    height: 56px;
    background: #1890FF;
    border-radius: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 56px;
    text-align: center;
    cursor: pointer;
}
.validationTip{
    position: fixed;
    left: 50%;
    bottom: 80px;
    transform: translateX(-50%);
    padding: 10px 20px;
    background: rgba(0, 0, 0, 0.75);
    border-radius: 8px;
    color: #FFFFFF;
    font-size: 14px;
    line-height: 22px;
    z-index: 10000;
}
.agreementModalMask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.45);
    z-index: 10001;
}
.agreementModal{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 420px;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 20px 20px 16px;
    box-sizing: border-box;
}
.agreementModalTitle{
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 18px;
    color: rgba(0,0,0,0.85);
    line-height: 26px;
}
.agreementModalClose{
    position: absolute;
    top: 16px;
    right: 16px;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    font-size: 20px;
    color: rgba(0,0,0,0.45);
    cursor: pointer;
}
.agreementModalContent{
    margin-top: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 22px;
}
.agreementModalActions{
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
}
.agreementModalBtn{
    min-width: 72px;
    height: 32px;
    border-radius: 4px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    line-height: 32px;
    text-align: center;
    cursor: pointer;
}
.agreementModalBtnCancel{
    border: 1px solid #D9D9D9;
    color: rgba(0,0,0,0.65);
    background: #FFFFFF;
}
.agreementModalBtnConfirm{
    border: 1px solid #1677FF;
    color: #FFFFFF;
    background: #1677FF;
}
</style>
<style scoped>
.left{
   position: absolute;
   top: 0;
   left: 0;
     width: 62.5%;
    height: 100%;
}
.leftCtn{
    position: absolute;
    left: calc(50% - 388px);
    width: 776px;
    height: 100%;
}
.leftText1{
    position: absolute;
    top: 6.3%;
    left: 0;
    width:auto;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: rgba(0,0,0,0.85);
    line-height: 32px;
}
.leftWhite{
    position: absolute;
    top: 13.5%;
    width: 776px;
    height: 78%;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);
    border-radius: 20px;
    overflow-x: hidden;
    overflow-y: auto;
}
.leftImg1{
    position: absolute;
    top: 6.97%;
    right: 308px;
    width: 16px;
}
.leftTxt1{
    position: absolute;
    top: 6.8%;
    right: 248px;
    width:auto;
    height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 20px;
}
.leftImg2{
    position: absolute;
    top: 7.25%;
    right: 220px;
    width: 8px;
    height: 12px;
}
.leftCircle{
    position: absolute;
    top: 6.97%;
    right: 60px;
    width: 16px;
    height: 16px;
    background: #1890FF;
    border-radius: 50%;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 16px;
    text-align: center;
}
.leftIcon1{
    position: relative;
    width: 32px;
    margin-top: 40px;
    margin-left: 40px;
}
.leftText2{
    position: absolute;
    top: 40px;
    left: 88px;
    width: auto;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: rgba(0,0,0,0.85);
    line-height: 32px;
}
.leftLine1{
    position: relative;
    margin-top: 24px;
    margin-left: 40px;
    width: 696px;
    height: 1px;
    border-top: 1px solid #D9D9D9;
}
.leftText4{
    position: relative;
    margin-top: 24px;
    margin-left: 40px;
    width: auto;
    height: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: rgba(0,0,0,0.85);
    line-height: 28px;
}
.leftMap{
    position: relative;
    margin-top: 16px;
    margin-left: 40px;
    width: 100px;
    height: 100px;
    background-color: cornflowerblue;
}
.leftImg3{
    position: absolute;
    top: 39px;
    left: 38px;
    width: 23px;
    cursor: pointer;
    z-index: 999;
}
.leftContract{
   position: relative;
   margin-top: 27px;
   margin-left: 40px;
   padding-left: 16px;
   width: 696px;
    height: 54px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 1px solid #D9D9D9; 
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 54px;
}
.leftContractInput{
    position: absolute;
    top: 0;
    left: 16px;
    width: 744px;
    height: 54px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 54px;
    border: none;
    outline: none;
    box-sizing: border-box;
}
.leftContractError{
    border: 1px solid #FF0000;
}
.leftContractInputError::placeholder{
    color: #FF0000;
}
.leftContractInputReadonly{
    cursor: default;
    user-select: text;
    color: rgba(0,0,0,0.65);
    background: transparent;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.leftContractInputReadonlyPlaceholder{
    color: rgba(0,0,0,0.25);
}
.leftContractNarrow{
    width: 417px;
}
.leftContractSelect{
    border-radius: 14px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    overflow: visible;
}
.leftSelectInput{
    position: absolute;
    left: 0;
    width: 100%;
    height: 54px;
    background: transparent;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    line-height: 54px;
    border: none;
    outline: none;
    cursor: pointer;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23BFBFBF' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 14px center;
    padding: 0 38px 0 16px;
    z-index: 2;
}
.leftSelectInput:hover{
    box-shadow: inset 0 0 0 1px #1677FF;
    border-radius: 14px;
}
.leftSelectValueText{
    display: inline-block;
    width: calc(100% - 40px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.leftSelectPanel{
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    width: 100%;
    max-height: 176px;
    overflow-y: auto;
    background: #FFFFFF;
    border: 1px solid #D9D9D9;
    border-radius: 12px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
    z-index: 50;
}
.leftSelectOption{
    height: 44px;
    line-height: 44px;
    padding: 0 16px;
    font-family: PingFangSC, PingFang SC;
    font-size: 14px;
    color: rgba(0,0,0,0.85);
    cursor: pointer;
}
.leftSelectOption:hover{
    background: #F5F8FF;
}
.leftSelectInputError{
    color: rgba(0,0,0,0.85);
}
.leftSelectPlaceholder{
    position: absolute;
    left: 16px;
    width: calc(100% - 32px);
    height: 54px;
    line-height: 54px;
    font-family: PingFangSC, PingFang SC;
    font-size: 14px;
    color: rgba(0,0,0,0.55);
    pointer-events: none;
}
.leftSelectPlaceholderError{
    color: #FF0000;
}
.leftTxt2{
    position: relative;
    margin-top: 16px;
    margin-left: 40px;
    width:auto;
    height: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 20px;
}
.leftText8{
    position: relative;
    margin-top: 40px;
    margin-left: 40px;
    width: auto;
    height: 28px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 20px;
    color: rgba(0,0,0,0.85);
    line-height: 28px;
}
.leftText9{
    position: absolute;
    top: 450px;
    left: 136px;
    width:auto;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 22px;
}
.leftText10{
    position: relative;
    margin-top: 24px;
    margin-left: 40px;
    margin-bottom: 40px;
    width: auto;
    height: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.65);
    line-height: 22px;
}
</style>
<style scoped>
.shadow{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 1000001;
    background: rgba(0,0,0,0.4);
}
.shadowWhite{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 776px;
    height: 428px;
    background: #FFFFFF;
    border-radius: 16px;
    border: 1px solid #979797;
}
.shadowClose{
    position: absolute;
    top: 28px;
    right: 40px;
    width: 20px;
    z-index: 1;
    font-size: 32px;
    color: #000000;
    cursor: pointer;
}
.shadowText1{
    position: absolute;
    top: 32px;
    width: 100%;
    height: 32px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 24px;
    color: rgba(0,0,0,0.85);
    line-height: 32px;
    text-align: center;
}
.shadowText2{
    position: absolute;
    top: 88px;
    left: 64px;
    width: 648px;
    height: 64px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0,0,0,0.65);
    line-height: 32px;
}
.shadowSel{
    position: absolute;
    top: 192px;
    left: 100px;
    width: 276px;
    height: 157px;
    cursor: pointer;
    background: rgba(0,0,0,0.4);
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);
    border-radius: 10px;
    overflow: hidden;
}
.shadowSel:hover{
    border: 2px solid #1890FF;
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);
    border-radius: 10px;
}
</style>

<!-- <style lang="scss" scoped>
.regionPanelBak{
    background: rgba(0,0,0,0.4);
    position: absolute;
    width: 100vw;
    height: calc(100vh - 76px);
    display: flex;
    align-items: center;
    justify-content: center;
    .regionPanel{
        width: 400px;
        height: 490px;
        background: #FFFFFF;
        border-radius: 20px;
        left: calc(50vw - 200px);
        top: calc(50vh - 245px);
        .regionPanelTitle{
            width: 120px;
            height: 28px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 20px;
            color: #000000;
            line-height: 28px;
            text-align: left;
            font-style: normal;
        }
        .regionPanelTips{
            width: 294px;
            height: 22px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            line-height: 22px;
            text-align: left;
            font-style: normal;
        }
    }
}
</style> -->
<style lang="scss" scoped>
.regionPanelBak{
    background: rgba(0,0,0,0.4);
    position: absolute;
    width: 100vw;
    height: calc(100vh - 76px);
    display: flex;
    align-items: center;
    justify-content: center;
    .regionPanel {
        width: 400px;
        height: 490px;
        background: #FFFFFF;
        border-radius: 20px;
        position: absolute;
        left: calc(50vw - 200px);
        top: calc(50vh - 245px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        overflow: hidden;

        // 标题栏：带关闭按钮
        .regionPanelTitle {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 24px 40px;
            font-family: 'PingFang SC', sans-serif;
            font-weight: 500;
            font-size: 20px;
            color: #000;
            line-height: 28px;

            span{
                margin-left: 100px;
            }
            // 关闭按钮样式（需配合 img）
            img {
                width: 20px;
                height: 20px;
                cursor: pointer;
                opacity: 0.7;
                transition: opacity 0.2s;
                &:hover {
                opacity: 1;
                }
            }
        }

        

        // 地图区域：占剩余空间，带边框示意
        .regionPanelMap {
            height: 335px;
            width: 335px;
            margin: 0px 32px 0 32px;
            background: #f5f5f5;
            position: relative;
            overflow: hidden;

            // 可选：添加背景图示意（如原型中的卫星图）
            // background-image: url('https://example.com/map-demo.jpg');
            // background-size: cover;
            // background-position: center;
        }

        // 提示文字：底部对齐
        .regionPanelTips {
            padding: 20px 20px;
            font-family: 'PingFang SC', sans-serif;
            font-weight: 400;
            font-size: 14px;
            color: #666;
            line-height: 22px;
            text-align: left;
        }
    }
}
</style>